export default "__VITE_ASSET__CY273OKZ__"